import { ChangeDetectionStrategy, Component, Inject, OnDestroy, OnInit } from "@angular/core";

import { Subscription } from "rxjs";
import { sessionStateServiceInjectionToken } from "../../global-states/session/session-state-service-injection-token";
import { ISessionStateService } from "../../global-states/session/i-session-state.service";
import { ICompany } from "../../models/i-company";
import { ILicense } from "../../models/i-license";
import { APP_VERSION } from "../../version";

@Component({
  selector: "app-info-modal",
  standalone: true,
  imports: [],
  templateUrl: "./info-modal.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class InfoModalComponent implements OnInit, OnDestroy {
  public readonly appVersion: string = APP_VERSION;
  public activeCompany: ICompany | null = null;
  public activeLicense: ILicense | null = null;

  private readonly _subscriptions: Subscription = new Subscription();

  constructor(
    @Inject(sessionStateServiceInjectionToken) private readonly _sessionStateService: ISessionStateService
  ) {}

  ngOnInit(): void {
    this.activeCompany = this._sessionStateService.getActiveCompany();
    this.activeLicense = this._sessionStateService.getActiveLicense();
  }

  ngOnDestroy(): void {
    this._subscriptions.unsubscribe();
  }
}
